module.exports = __webpack_public_path__ + "img/special_11.92acb209.png";